import { api } from '../../lib/api.ts';

export interface Vendor {
  id: string;
  name: string;
  address: string | null;
  phone: string | null;
  idCardNumber: string;
  bankAccountNumber: string | null;
  bankAccountName: string | null;
  email: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  types: { id: string; name: string }[];
  credentialsSentAt: string | null;
  hasCredentials: boolean;
  headerImagePath: string | null;
  footerImagePath: string | null;
  footerText: string | null;
}

export interface VendorListResult {
  vendors: Vendor[];
  total: number;
  page: number;
  pageSize: number;
}

export interface VendorInput {
  name: string;
  phone?: string;
  idCardNumber: string;
  address?: string;
  bankAccountNumber?: string;
  bankAccountName?: string;
  email?: string;
  typeIds?: string[];
}

export const vendorsApi = {
  list: (params: { page?: number; pageSize?: number; search?: string } = {}) =>
    api.get<VendorListResult>('/vendors', { params }).then((r) => r.data),
  create: (input: VendorInput) =>
    api.post<{ vendor: Vendor }>('/vendors', input).then((r) => r.data.vendor),
  get: (id: string) =>
    api.get<{ vendor: Vendor }>(`/vendors/${id}`).then((r) => r.data.vendor),
  update: (id: string, input: Partial<VendorInput>) =>
    api.patch<{ vendor: Vendor }>(`/vendors/${id}`, input).then((r) => r.data.vendor),
  deactivate: (id: string) =>
    api.post<{ vendor: Vendor }>(`/vendors/${id}/deactivate`).then((r) => r.data.vendor),
  activate: (id: string) =>
    api.post<{ vendor: Vendor }>(`/vendors/${id}/activate`).then((r) => r.data.vendor),
  sendCredentials: (id: string) =>
    api
      .post<{ ok: true; credentialsSentAt: string }>(`/vendors/${id}/send-credentials`)
      .then((r) => r.data),
  // Per-vendor letterhead — mirrors org-settings header/footer/text endpoints.
  // dataBase64: null clears the image (falls back to the org default).
  setLetterheadImage: (id: string, kind: 'header' | 'footer', dataBase64: string | null, mime?: string | null) =>
    api
      .put<{ vendor: Vendor }>(`/vendors/${id}/letterhead`, { kind, dataBase64, mime: mime ?? null })
      .then((r) => r.data.vendor),
  setFooterText: (id: string, footerText: string | null) =>
    api
      .patch<{ vendor: Vendor }>(`/vendors/${id}/letterhead/footer-text`, { footerText })
      .then((r) => r.data.vendor),
};
